import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Tabs = ({ homedata }) => {
  const [activeTab, setActiveTab] = useState("gold");
  const recentCategories = homedata?.maincategorylist || [];

  console.log(recentCategories);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const searchData = searchParams.get("search");

  console.log(searchData);

  const serr = searchData ? searchData : "silver-jewellery";

  console.log(serr);

  const navigate = useNavigate();

  return (
    <div className="tab-wrapper px-2 mt-1">
      <div className="tab-container">
        {/* Gold Tab */}

        {recentCategories &&
          recentCategories?.map((data, i) => {
            return (
              <button
                className={`tab-btn ${serr === data?.slug ? "silver-active" : ""}`}
                onClick={() => navigate("?search=" + data?.slug)}
              >
                <span className="tab-icon">✨</span>
                <span>{data?.name}</span>
              </button>
            );
          })}
        {/* <button
          className={`tab-btn ${activeTab === "gold" ? "gold-active" : ""}`}
          onClick={() => setActiveTab("gold")}
        >
          <span className="tab-icon">✨</span>
          <span>Gold Jewellery</span>
        </button> */}

        {/* Silver Tab */}
        {/* <button
          className={`tab-btn ${activeTab === "silver" ? "silver-active" : ""}`}
          onClick={() => setActiveTab("silver")}
        >
          <span className="tab-icon">💍</span>
          <span>Silver Jewellery</span>
        </button>
        <button
          className={`tab-btn ${activeTab === "silvers" ? "silver-active" : ""}`}
          onClick={() => setActiveTab("silvers")}
        >
          <span className="tab-icon">💍</span>
          <span>Silver Jewellery</span>
        </button>
        <button
          className={`tab-btn ${activeTab === "silverm" ? "silver-active" : ""}`}
          onClick={() => setActiveTab("silverm")}
        >
          <span className="tab-icon">💍</span>
          <span>Silver Jewellery</span>
        </button>
        <button
          className={`tab-btn ${activeTab === "silvermr" ? "silver-active" : ""}`}
          onClick={() => setActiveTab("silvermr")}
        >
          <span className="tab-icon">💍</span>
          <span>Silver Jewellery</span>
        </button> */}
      </div>
    </div>
  );
};

export default Tabs;
